module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/6VK58L/tc-custom/9781426844065.jpg?1725275587492",
      "alt": "This image is the cover for the book Valley of Shadows"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Valley of Shadows\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Working deep undercover was dangerous. Mercenary turned DEAagent Hawke Morran found out just how dangerous when his coverwas suddenly blown. His life hung in the balance—until a mysteriouswoman saved him from certain death. "), _c('br'), _c('br'), _vm._v("Hawke was a lone wolf—used to bringing down the bad guys byhimself. Without a partner. Yet now he and Miranda Shelton wererunning for their lives, desperate to uncover the identity of Hawke'sbetrayor. Journeying from the mountains of Lakeview, Virginia, tothe valleys of Thailand, Hawke vowed to protect the lovely Christian woman in his care.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Shirlee McCoy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Aside from her faith and her family, there’s not much Shirlee McCoy enjoys more than a good book! When she’s not hanging out with the people she loves most, she can be found plotting her next Love Inspired Suspense story or trekking through the wilderness, training with a local search-and-rescue  team. Shirlee loves to hear from readers. If you have time, drop her a line at shirleermccoy@hotmail.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin Enterprises\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0